import BaseAPI from '@/services/api/internal/tools/baseAPI';

const AuthorizationsAPI = new BaseAPI({
  url: `${process.env.USER_PREFERENCES_BASE_URI}/user_profile`,
});

export default AuthorizationsAPI;
